import {RequestInfo} from "@khan/shared-core";

/**
 * Get a publicly accessible URL that is canonical.
 *
 * This serves two purposes:
 *
 * 1. It returns a URL that is publicly accessible, even when testing locally.
 *    This is useful when testing Open Graph objects (e.g. badges, videos), as
 *    this URL will point to already-deployed pages that Facebook can crawl and
 *    which are associated with our Facebook app.
 *
 * 2. It always returns an HTTPS URL. By always returning HTTPS, we prevent an
 *    issue where a page has two "canonical" urls - one HTTP, and one HTTPS.
 *    Instead we call the HTTPS page canonical.
 *
 * Examples for relative_url == "/badges/getting-started":
 *  Host beta.wild.khanacademy.org =>
 *      https://beta.wild.khanacademy.org/badges/getting-started
 *  Host 127.0.0.1 =>
 *      https://www.khanacademy.org/badges/getting-started
 *  Host khan-academy.appspot.com =>
 *      https://www.khanacademy.org/badges/getting-started
 *
 * @param relativeUrl The URL to be converted.
 * @returns The canonical URL as a string.
 */
export const toCanonicalUrl = (
    relativeUrl: string,
    forceKaLocale?: string,
): string => {
    // TODO(somewhatabstract, FEI-6515): We need to update this to support our
    // non-Khan Classic subdomain-based product URLs, like
    // classroom.khanacademy.org.
    const kaLocale = forceKaLocale || RequestInfo.kaLocale;
    const subdomain = kaLocale === "en" ? "www" : kaLocale;

    return `https://${subdomain}.khanacademy.org${relativeUrl}`;
};
